import React, { useEffect, useState } from "react";
import { Bar, Doughnut } from "react-chartjs-2";
import {
  FaRegCalendarCheck,
  FaCalendarWeek,
  FaCalendarAlt,
} from "react-icons/fa";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import featureService from "../api/services/dashbaordService";
import Loading from "../components/Loading";

ChartJS.register(ArcElement, Tooltip, Legend);
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const Home = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const result = await featureService.fetchAll();
        console.log("Dashboard data:", result);
        if (result?.responseCode === 200) {
          setDashboardData(result);
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (!dashboardData) {
    return (
      <>
        <div className="w-full flex justify-center items-center">
          <Loading />
        </div>
      </>
    );
  }

  const {
    usersAnalytics,
    proposalsAnalytics,
    chatAnalytics,
    premium,
    latest,
    genderDistribution,
    weekGenderDistribution,
  } = dashboardData;

  const filteredPremium = (premium || []).filter(
    (user) => !user.email || !user.email.toLowerCase().endsWith("@naseebimail.com")
  );

  const filteredLatest = (latest || []).filter(
    (user) => !user.email || !user.email.toLowerCase().endsWith("@naseebimail.com")
  );

  // Doughnut chart for gender
const genderData = {
  labels: ["Male", "Female"],
  datasets: [
    {
      label: "Gender Distribution",
      data: [genderDistribution.males, genderDistribution.females],
      backgroundColor: ["#FB565F", "black"],
    },
  ],
   
};

const options = {
  cutout: "70%", // default ~50%, zyada value = patli ring

};  


  // Weekly bar chart
  const weekLabels = weekGenderDistribution.map((d) => d.day);
  const maleData = weekGenderDistribution.map((d) => d.males);
  const femaleData = weekGenderDistribution.map((d) => d.females);

  const weeklyChart = {
    labels: weekLabels,
    datasets: [
      {
        label: "Male",
        data: maleData,
        backgroundColor: "#FB565F",
        borderRadius: 5,
      },
      {
        label: "Female",
        data: femaleData,
        backgroundColor: "black",
        borderRadius: 5,
      },
    ],
  };

  return (
    <>
      <div className={`rounded-xl w-full h-full min-h-[calc(100vh-120px)]`}>
        {loading ? (
          <div className="flex justify-center items-center">
            <Loading />
          </div>
        ) : (
          <div className="">
            {/* Overview Section */}
            <div className="grid grid-cols-1 lg:grid-cols-[60%_40%] gap-4 mb-3">
              <div className="w-full bg-white rounded-xl shadow-md">
                <div className="flex flex-col gap-3 py-6 px-4 h-full">
                  <div className="font-main font-semibold text-black text-left text-xl">
                    Overview
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 text-center mt-2 px-3 h-full">
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Today Users
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {usersAnalytics.today}
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="text-black  font-[700]  font-main  text-left">
                        Monthly Users
                      </div>
                      <div className="font-main text-left text-3xl text-gray-900 font-[600]">
                        {usersAnalytics.month}
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Total Users
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {usersAnalytics.total}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Proposals & Chats summary */}
              <div className="w-full bg-white rounded-xl shadow-md">
                <div className="flex flex-col gap-3 py-6 px-4">
                  <div className="font-main font-semibold text-black text-left text-xl">
                    Proposals and Chats
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-center mt-2 px-3 h-full">
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Total Proposals
                      </div>
                      <div className="text-3xl text-left font-main text-gray-900 font-[600]">
                        {proposalsAnalytics.total_proposals}
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 p-4 rounded-xl bg-white border">
                      <div className="font-main text-black  font-[700] text-left">
                        Total Chats
                      </div>
                      <div className="font-main text-left text-3xl text-gray-900 font-[600]">
                        {chatAnalytics.total}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Charts */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
              <div className="bg-white rounded-xl shadow-md p-5">
                <div className="font-main text-center font-semibold text-xl">
                  Users Distribution
                </div>
                <div className="mt-2 flex justify-center h-56 sm:h-64">
                {/* <div classNam  style={{ width: "310px", height: "310px" }}> */}
                  <Doughnut data={genderData} options={{ ...options, responsive: true, maintainAspectRatio: false }} />
                  {/* </div> */}
                </div>
              </div>
              <div className="font-main bg-white rounded-xl shadow-md p-5 lg:col-span-2">
                <div className="text-center font-main font-semibold text-xl">
                  Weekly Progress
                </div>
                <div className="mt-2 h-56 sm:h-64">
                  <Bar data={weeklyChart} options={{ responsive: true, maintainAspectRatio: false }} />
                </div>
              </div>
            </div>

            {/* Proposals & Chats Details */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 mt-5 mb-5">
  {/* ===== Daily Proposals ===== */}
  <div className="col-span-2">
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Daily Proposals
    </h2>
    <div className="grid grid-cols-2 gap-4">
      {/* Sent */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Sent Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.today_proposals}</p>
      </div>
      {/* Accepted */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Accepted Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.today_accepted_proposals}</p>
      </div>
    </div>
  </div>

  {/* ===== Monthly Proposals ===== */}
  <div className="col-span-2">
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Monthly Proposals
    </h2>
    <div className="grid grid-cols-2 gap-4">
      {/* Sent */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Sent Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.month_proposals}</p>
      </div>
      {/* Accepted */}
      <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
        <p className="text-gray-700 font-[500]">Accepted Proposals</p>
        <p className="text-3xl font-bold">{proposalsAnalytics.month_accepted_proposals}</p>
      </div>
    </div>
  </div>

  {/* ===== Daily Chats ===== */}
  <div>
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Daily Chats
    </h2>
    <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
      <p className="text-gray-700 font-[500]">Today</p>
      <p className="text-3xl font-bold">{chatAnalytics.today}</p>
    </div>
  </div>

  {/* ===== Monthly Chats ===== */}
  <div>
    <h2 className="text-lg font-main font-bold text-left text-black mb-3">
      Monthly Chats
    </h2>
    <div className="flex flex-col p-4 gap-2 font-main shadow-md bg-white rounded-xl">
      <p className="text-gray-700 font-[500]">Monthly</p>
      <p className="text-3xl font-bold">{chatAnalytics.month}</p>
    </div>
  </div>
</div>


            {/* Premium & Latest Users */}
            <div className="w-full gap-6 lg:gap-10 flex flex-col md:flex-row justify-between col-span-1 lg:col-span-2 bg-white rounded-xl shadow-md p-4 md:p-6">
              <div className="w-full md:w-1/2 rounded-lg p-2 md:p-4 shadow-sm overflow-x-auto">
                <h2 className="font-main text-lg font-semibold text-red-500  pb-2 mb-4">
                  Premium Users
                </h2>

                {filteredPremium?.length > 0 ? (
                  <div className="">
                    <table className="min-w-full border border-gray-200 rounded-lg text-xs sm:text-sm">
                      <thead className="bg-gray-100">
                        <tr>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            First Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Last Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Email
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Gender
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredPremium.map((user, index) => (
                          <tr
                            key={index}
                            className="font-main hover:bg-green-50 border-t border-gray-200"
                          >
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.firstName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.lastName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.email}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.gender}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-500 text-sm font-main ">
                    No premium users found
                  </p>
                )}
              </div>

              <div className="w-full md:w-1/2 rounded-lg p-2 md:p-4 shadow-sm overflow-x-auto">
                <h2 className="font-main text-lg text-red-500 font-semibold  pb-2 mb-4">
                  Latest Users (Top 10)
                </h2>

                {filteredLatest?.length > 0 ? (
                  <div className="">
                    <table className="min-w-full border border-gray-200 rounded-lg text-xs sm:text-sm">
                      <thead className="font-main bg-gray-100">
                        <tr>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            First Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Last Name
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Email
                          </th>
                          <th className="font-main px-4 py-2 text-left text-sm text-black  font-[700]">
                            Gender
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLatest.map((user, index) => (
                          <tr
                            key={index}
                            className="font-main hover:bg-blue-50 border-t border-gray-200"
                          >
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.firstName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.lastName}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.email}
                            </td>
                            <td className="font-main px-4 py-2 text-sm text-gray-700">
                              {user.gender}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <p className="text-gray-500 text-sm font-main">
                    No latest users found
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Home;
